import React from 'react';
import { Box, Popover } from '@mui/material';
import { getEmojiImagePath, getSkinToneVariations } from '../../../../../../../utilities/emojiUtils';

const styles = {
    popoverPaper: {
        borderRadius: 2,
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        overflow: 'hidden'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: 0.5,
        p: 1,
        bgcolor: 'background.paper'
    },
    skinToneButton: (isSelected) => ({
        border: 'none',
        cursor: 'pointer',
        p: 1,
        borderRadius: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: isSelected ? 'action.selected' : 'transparent',
        transition: 'all 0.2s',
        width: 48,
        height: 48,
        '&:hover': {
            bgcolor: isSelected ? 'action.selected' : 'action.hover',
            transform: 'scale(1.1)'
        },
        '&:active': {
            transform: 'scale(0.95)'
        }
    })
};

const SkinTonePicker = ({ 
    isOpen, 
    anchorEl, 
    onClose, 
    baseUnicodeId, 
    selectedUnicodeId, 
    onSelect 
}) => {
    const variations = getSkinToneVariations(baseUnicodeId);

    if (variations.length === 0) {
        return null;
    }

    const handleSelect = (unicode) => {
        onSelect(unicode);
        onClose();
    };

    return (
        <Popover
            open={isOpen}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
            PaperProps={{ sx: styles.popoverPaper }}
            slotProps={{
                paper: {
                    onMouseLeave: onClose
                }
            }}
        >
            <Box sx={styles.container}>
                {variations.map((variation, index) => (
                    <Box
                        key={index}
                        component="button"
                        onClick={() => handleSelect(variation.unicode)}
                        sx={styles.skinToneButton(selectedUnicodeId === variation.unicode)}
                        title={variation.label}
                    >
                        <img 
                            src={getEmojiImagePath(variation.unicode)} 
                            alt={variation.label} 
                            loading="eager"
                            decoding="async"
                            style={{ width: 32, height: 32, display: 'block' }} 
                        />
                    </Box>
                ))}
            </Box>
        </Popover>
    );
};

export default SkinTonePicker;
